import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { isEmptyArr } from '@utils/index';
import { useMutation } from 'react-query';

export function useAnswerSimulate(text: string) {
  const location = useLocation();

  const segments = location.pathname.split('/');
  const agentId = segments[2];
  const selectedLead = useAppSelector(state => state.aiAgentReducer.simulation.selectedLead);
  const selectedContract = useAppSelector(state => state.aiAgentReducer.simulation.selectedContract);
  const messages = useAppSelector(state => state.aiAgentReducer.messages);
  const dataType = useAppSelector(state => state.aiAgentReducer.body.dataType);
  const type = useAppSelector(state => state.aiAgentReducer.body.type);

  const isDebt = dataType === 'DEBT' && type === 'CALL';

  const body = {
    text: isDebt ? '' : text,
    dataId: isDebt ? selectedContract?.contractId : selectedLead?.id,
    isNew: isEmptyArr(messages)
  };

  return useMutation({
    mutationFn: async () => {
      const res = await $api.post(`/v1/chat-flow/answer/simulate/${agentId}`, body);

      return res.data.data;
    }
  });
}
